import React from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
} from "@mui/material";
import ReusableCarousel from "../../elements/ReusableCarousel";
import theme from "../../elements/Theme";
import { testimonials } from "./testimonials";
import { responsive } from "../../utils/responsive";

const ReviewFrame: React.FC = () => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const renderTestimonialCard = (testimonial: any, index: number) => (
    <Card
      key={index}
      sx={{
        backgroundColor: "rgb(255 154 49 / 5%)",
        color: "black",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: "0 10px",
        padding: "2% 10%",
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: "600px",
        }}
      >
        <Typography variant="h5" fontWeight={600}>
          {t(
            `ReviewFrame.testimonials.testimonial_${testimonial.id}.${testimonial.titleKey}`
          )}
        </Typography>
        <Typography variant="h5" fontWeight={400}>
          {t(
            `ReviewFrame.testimonials.testimonial_${testimonial.id}.${testimonial.textKey}`
          )}
        </Typography>
        <Typography variant="h5" fontWeight={600}>
          {t(
            `ReviewFrame.testimonials.testimonial_${testimonial.id}.${testimonial.authorKey}`
          )}
        </Typography>
      </CardContent>
    </Card>
  );
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.primary.main,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: isMobile ? "10vh" : "10vh",
      }}
    >
      {!isMobile && (
        <img
          src="/birds/red.webp"
          alt="Описание"
          style={{
            position: "absolute",
            transform: " translate(-120%, -45%) scaleX(-1) rotate(-30deg)",
            width: "40%",
            height: "auto",
          }}
        />
      )}
      <Typography
        variant="h2"
        fontWeight="800"
        color={theme.palette.text.secondary}
        textAlign="center"
        mb="8vh"
      >
        {t("ReviewFrame.title")}
      </Typography>
      <Box width={isMobile ? "100%" : "80%"} padding={"4%"}>
        <ReusableCarousel
          items={testimonials}
          renderItem={renderTestimonialCard}
          responsive={responsive}
        />
      </Box>
    </Box>
  );
};

export default ReviewFrame;
